module.exports = {
  // успешный сценарий:
  booked: 'Забронирована',
  doccheck: 'На проверке документов',
  going: 'В пути',
  delayed: 'Опаздывает',
  waiting: 'Ожидается',
  inprogress: 'Выполняется',
  completed: 'Завершена',
  confirmed: 'Подтверждена', // = оплачена
  checkingin: 'Выход не подтверждён',
  checkingout: 'Конец смены не подтверждён',

  // проблемные:
  toolate: 'Отменена из-за опоздания',
  revoked: 'Отменена заказчиком',
  cancelled: 'Отменена',
  expired: 'Просрочена',
  failed: 'Не выполнена',

  // deprecated:
  new: 'Новая',
};
